import React from "react";
import clsx from "clsx";

type Props = {
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
};

export const Badge = ({ children, className, size = "md" }: Props) => {
  return (
    <span
      className={clsx(
        "rounded-full font-medium inline-flex items-center",
        {
          "text-[10px] px-2 py-0.5": size === "sm",

          "text-xs px-3 py-1": size === "md",

          "text-sm px-4 py-1.5": size === "lg",
        },
        className
      )}
    >
      {children}
    </span>
  );
};